<template>
  <div>
    <div class="custom-select-container" @click="toggleDropdown">
      <div class="custom-select-display">
        {{ selectedOption ? $t(selectedOption.text) : '' }}
      </div>
      <div v-if="isOpen" class="custom-select-dropdown">
        <div
          v-for="option in options"
          :key="option.value"
          class="custom-select-option"
          :class="{'selected-option': selectedOption && selectOption.value && option.value === selectedOption.value && !hoveredOption, 'hovered-option': option.value === hoveredOption}"
          @mouseover="hoveredOption = option.value"
          @mouseleave="hoveredOption = null"
          @click.stop="selectOption(option)">
          <div class="option-main-text">{{ $t(option.text) }}</div>
          <ul v-if="option.details && option.details.length > 0" class="option-details">
            <li v-for="detail in option.details" :key="detail">{{ $t(detail) }}</li>
          </ul>
        </div>

      </div>
    </div>

    <div v-if="!isValid" class="invalid-feedback">{{ invalidFeedback }}</div>
  </div>
</template>

<script>
export default {
  name: "CustomTvaSelect",
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Object, null],
      default: null,
    },
    invalidFeedback: {
      type: String,
      default: "",
    },
    isValid: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedOption: null,
      hoveredOption: null, // État temporaire pour le hover
    };
  },

  mounted() {
    this.selectedOption = this.options.find((opt) => opt.value === this.value);
    document.addEventListener("click", this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.selectedOption = option;
      this.isOpen = false;
      this.$emit("input", option.value);
    },
  },
  watch: {
    value(newVal) {
      this.selectedOption = this.options.find((opt) => opt.value === newVal) || null;
    },
  },
};
</script>

<style scoped>
.custom-select-container {
  position: relative;
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 5px;
  padding: 8px;
  display: inline-block;
  height: calc(1.5em + .75rem + 2px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") right .75rem center/8px 10px no-repeat;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.custom-select-display {
  font-weight: 400;
  padding-left: 4px;
  color: #495057;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-select-dropdown {
  position: absolute;
  left: 0;
  top: 101%;
  background: #fff;
  border-bottom: 1px solid #adb5bd;
  border-left: 1px solid #adb5bd;
  border-right: 1px solid #adb5bd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  overflow-y: auto;
  z-index: 1000;
}
.custom-select-option {
  padding: 4px 4px 4px 12px;
  cursor: pointer;
  font-weight: 700;
  border-bottom: 1px solid #adb5bd;
}
.custom-select-option.selected-option {
  background-color: rgb(25, 103, 210);
  color: #fff !important;
}

.custom-select-option.hovered-option {
  background-color: rgb(25, 103, 210); /* Bleu natif */
  color: #fff !important;
}

/* Pour éviter que l'option sélectionnée reste active lorsqu'une autre est hover */
.custom-select-option.selected-option.hovered-option {
  background-color: rgb(25, 103, 210); /* Même style */
  color: #fff !important;
}


.custom-select-option.hovered-option .option-main-text,
.custom-select-option.hovered-option .option-details,
.custom-select-option.selected-option .option-main-text,
.custom-select-option.selected-option .option-details {
  color: #fff !important;
}

.option-main-text {
  color: var(--main-text-color);
}
.option-details {
  margin-top: 5px;
  padding-left: 3rem;
  font-size: 0.9em;
  font-weight: 400;
}
.invalid-feedback {
  color: #dc3545;
  font-size: 0.9em;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomTvaSelect.vue